import { defineComponent as _defineComponent } from 'vue'
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { generateUID } from '../../../helpers/uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const uid = generateUID(6);

const formElement = useFormElement({
  emit,
  props,
});

const { readonly, inputName } = useBaseFieldValues(formElement);

const { modelStateRef, model, field, getSlotName, setValue } = formElement;

const inputClass = modelStateRef('inputClass', 'custom-control custom-radio');

const options = modelStateRef('options');

const inline = modelStateRef('inline', false);

function optionName(option: any) {
  return typeof option === 'string' ? option : option.label;
}

function optionValue(option: any) {
  return typeof option === 'string' ? option : option.value;
}

function isOptionDisabled(option: any) {
  return readonly.value || option?.disabled === true;
}

return { __sfc: true,props, emit, uid, formElement, readonly, inputName, modelStateRef, model, field, getSlotName, setValue, inputClass, options, inline, optionName, optionValue, isOptionDisabled }
}

})